import { embed } from './embed'
import { feedbackContinue, feedbackInput, feedbackSend, initializeFeedbackTextarea } from './feedback'
import { highlightSearchTerms } from './search'
import { initializeButtonListeners } from './input'
import { initializeCtaClickReporting } from './cta'
import { initializeLightbox } from './lightbox'
import {
    initializePublicationLinkClickReporting,
    restoreReactions,
    sendBadReaction,
    sendGoodReaction,
    sendNeutralReaction,
} from './publication'
import { replacePublicationTimeValues } from './publication-time'
import { setupAutoRefresh } from './auto-refresh'

import 'regenerator-runtime'
import { createOrExtendUserId } from './identity'
import { getProjectId } from './utility'
;(async () => {
    onDomContentLoaded(() => {
        replacePublicationTimeValues()
        restoreReactions()
        highlightSearchTerms()
        initializeButtonListeners()
        initializeFeedbackTextarea()
        initializeCtaClickReporting()
        initializePublicationLinkClickReporting()
        initializeLightbox()
    })

    if (!(await embed())) {
        createOrExtendUserId(getProjectId())
    }

    setupAutoRefresh()

    registerFunction('feedbackContinue', feedbackContinue)
    registerFunction('feedbackInput', feedbackInput)
    registerFunction('feedbackSend', feedbackSend)
    registerFunction('sendBadReaction', sendBadReaction)
    registerFunction('sendGoodReaction', sendGoodReaction)
    registerFunction('sendNeutralReaction', sendNeutralReaction)
})()

function onDomContentLoaded(func: Function) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', (e) => {
            func()
        })
    } else {
        func()
    }
}

function registerFunction(name: string, func: Function) {
    window.noticeable.functions[name] = func
}
